module.exports = __webpack_public_path__ + "img/p6.70d96f72.jpg";